import React from "react";
import { Link } from "react-router-dom";

import classes from "./Header.module.scss";
import logo from "./../../../assets/img/Boxi_white_Icon.png";
import LogoutIcon from '@mui/icons-material/Logout';

const Header = () => {
  return (
    <div className={classes.header}>
      <img className={classes.logo} src={logo} alt="Boxi Logo" />
      <div className={classes.logout}>
      <Link to="/dashboard/logout" className={classes.button}>
           <LogoutIcon /> Logout
      </Link>
      </div>
    </div>
  );
};

export default Header;
